import React from "react";

const RefundCancellationPolicy = () => {
  return (
    <div className="light-background">
    <div className="container">
    <section
      id="refund-cancellation"
      className="contact section light-background py-5"
      style={{ backgroundColor: "#f3f9ff", scrollMarginTop: "90px" }}
    >
      <div className="container section-title mb-3 pt-5">
        <h2 className="fw-bold text-dark text-center">Refund and Cancellation Policy</h2>
      </div>
      <div className="container">
        <div className="row g-4 g-lg-4 align-items-stretch">
          {/* Left Column */}
          <div className="col-lg-4">
            <div className="info-box bg-white p-4 rounded shadow-sm text-dark "style={{height:'490px'}}>
              <p>
                If you have any comments, concerns or questions about this Refund and Cancellation Policy, please contact us at{" "}
                <a href="mailto:info@logesolutions.net" className="text-success">
                  info@logesolutions.net
                </a>
              </p>

              <div className="info-item d-flex align-items-start mb-3">
                <div className="icon-box me-3 bg-success d-flex justify-content-center align-items-center p-2 rounded-circle" style={{ width: 40, height: 40 }}>
                  <i className="bi bi-house text-white fs-5"></i>
                </div>
                <div>
                  <h4 className="mb-1 fw-bold text-dark">Company</h4>
                  <p className="mb-0 text-dark">Log e infotech Pvt. Ltd.</p>
                </div>
              </div>

              <div className="info-item d-flex align-items-start mb-3">
                <div className="icon-box me-3 bg-success d-flex justify-content-center align-items-center p-2 rounded-circle" style={{ width: 40, height: 40 }}>
                  <i className="bi bi-geo-alt text-white fs-5"></i>
                </div>
                <div>
                  <h4 className="mb-1 fw-bold text-dark">Our Location</h4>
                  <p className="mb-0 text-dark">Shop no. 18, Srno- 81/1, bandal capital,</p>
                  <p className="mb-0 text-dark">Near Kothrud depo, paud road, Kothrud,</p>
                  <p className="mb-0 text-dark">India - MH - Pune - 411038</p>
                </div>
              </div>

              <div className="info-item d-flex align-items-start mb-3">
                <div className="icon-box me-3 bg-success d-flex justify-content-center align-items-center p-2 rounded-circle" style={{ width: 40, height: 40 }}>
                  <i className="bi bi-telephone text-white fs-5"></i>
                </div>
                <div>
                  <h4 className="mb-1 fw-bold text-dark">Phone Number</h4>
                  <p className="mb-0 text-dark">+91 7773967002</p>
                  <p className="mb-0 text-dark">+91 7028287002</p>
                </div>
              </div>

              <div className="info-item d-flex align-items-start ">
                <div className="icon-box me-3 bg-success d-flex justify-content-center align-items-center p-2 rounded-circle" style={{ width: 40, height: 40 }}>
                  <i className="bi bi-envelope text-white fs-5"></i>
                </div>
                <div>
                  <h4 className="mb-1 fw-bold text-dark">Email Address</h4>
                  <p className="mb-0 text-dark">info@logesolutions.net</p>
                  <p className="mb-0 text-dark">contact@logesolutions.net</p>
                </div>
              </div>
            </div>
          </div>

          {/* Right Column */}
          <div className="col-lg-8">
            <div
              className="contact-form bg-white p-4 rounded shadow-sm text-dark h-100"
              style={{
                overflowY: "auto",
                maxHeight: "490px",
                scrollbarWidth: "none",
                msOverflowStyle: "none"
              }}
            >
              <p>
                Thank you for choosing <strong>Log e Infotech Pvt. Ltd.</strong>. We strive to provide excellent service and ensure customer satisfaction. Please review our refund and cancellation policy below.
              </p>
              <h5>1. Service Cancellation</h5>
              <p>
                Clients may cancel scheduled services by providing notice at least <strong>15</strong> days in advance of the scheduled service date, via email at <strong>info@logesolutions.net</strong> or phone at <strong>+91 7773967002</strong>.
              </p>
              <ul>
                <li>Cancellations made with sufficient notice will receive a full refund.</li>
                <li>Cancellations made less than 15 days before the service date may be subject to a cancellation fee of 10%.</li>
              </ul>
              <h5>2. Refund Eligibility</h5>
              <p>Refunds are considered under the following circumstances:</p>
              <ul>
                <li>The service was not provided as described.</li>
                <li>The service was not delivered due to unforeseen circumstances on our part.</li>
              </ul>
              <p>To request a refund, please contact us at <strong>info@logesolutions.net</strong> within 15 days of the service date.</p>
              <h5>3. Non-Refundable Services</h5>
              <p>Certain services are non-refundable, including:</p>
              <ul>
                <li>Services that have been fully rendered.</li>
                <li>Notification Service or third party packages like AWS, Video, Image, SMS, WhatsApp, Email, Payment etc.</li>
              </ul>
              <h5>4. Processing Refunds</h5>
              <p>Approved refunds will be processed and issued within 15 business days. Processing times may vary depending on your financial institution.</p>
              <h5>5. Partial Refunds</h5>
              <p>If a service has been partially rendered or partially completed, partial refunds may be issued at our discretion, based on the proportion of the service completed.</p>
              <h5>6. Force Majeure</h5>
              <p>We are not liable for delays or cancellations caused by events beyond our reasonable control, including but not limited to natural disasters, strikes, governmental actions, or other force majeure events.</p>
              <h5>7. Governing Law</h5>
              <p>This Refund and Cancellation Policy shall be governed by and construed in accordance with the laws of India, including the Consumer Protection Act, 2019, and other applicable laws. Any disputes arising under or in connection with this policy shall be subject to the exclusive jurisdiction of the courts located in Shivaji Nagar, Pune, Maharashtra.</p>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        /* Hide scrollbar for Chrome, Safari and Opera */
        .contact-form::-webkit-scrollbar {
          display: none;
        }
      `}</style>
    </section>
    </div>
    </div>
  );
};

export default RefundCancellationPolicy;
